import { cn } from '@sohanemon/utils';
import * as m from 'motion/react-m';
import { useMotionTemplate, useMotionValue } from 'motion/react';
import type { ComponentProps, MouseEvent } from 'react';
import { MotionProvider } from './motion';

export function Spotlight({
	className,
	children,
	...props
}: ComponentProps<'div'>) {
	const mouseX = useMotionValue(0);
	const mouseY = useMotionValue(0);

	function handleMouseMove({ currentTarget, clientX, clientY }: MouseEvent) {
		const { left, top } = currentTarget.getBoundingClientRect();
		mouseX.set(clientX - left);
		mouseY.set(clientY - top);
	}

	return (
		<MotionProvider>
			<div
				role="presentation"
				className={cn('group relative', className)}
				{...props}
				onMouseMove={handleMouseMove}
			>
				<m.div
					className="pointer-events-none absolute -inset-px rounded-xl corner-bevel opacity-0 transition duration-300 group-hover:opacity-100"
					style={{
						background: useMotionTemplate`radial-gradient(450px circle at ${mouseX}px ${mouseY}px, rgba(14, 165, 233, 0.35), transparent 80%)`,
					}}
				/>
				{children}
			</div>
		</MotionProvider>
	);
}
